<template>
  <div style="padding: 20px;">
    <LoaderView v-if="meal == null" />

    <div v-else>
      <div style="display: flex; gap: 10px; align-items: center; margin-bottom: 1rem; justify-content: space-between;">
        <!-- Go back-->
        <button class="button gray" @click="$router.go(-1)">
          <font-awesome-icon class="icon" :icon="['fas', 'arrow-left']" />
          Retour
        </button>

        <div class="form-title" style="text-align: center;">
          Mon {{ mealDisplay }} du {{ humanizeDate(dateParam) }}
        </div>

        <div />
      </div>

      <!-- 🥘 DishCard (corrigé avec les 3 props obligatoires) -->
      <DishCard v-for="(dishItem, index) in meal" :key="index" :recipe="dishItem.dish" :item="dishItem"
        :adjustedIngredients="dishItem.ajusted_ingredients" @update="reload" />
    </div>
  </div>
</template>

<script>
import { api } from "@/api";
import LoaderView from "@/components/LoaderView.vue";
import DishCard from "@/views/DishCard.vue";

export default {
  name: "MyMealView",
  components: {
    LoaderView,
    DishCard,
  },
  data() {
    return {
      meal: null,
    };
  },
  computed: {
    dateParam() {
      return this.$route.params.date;
    },
    mealParam() {
      return this.$route.params.meal;
    },
    mealDisplay() {
      return {
        lunch: "Déjeuner",
        dinner: "Dîner",
        diner: "Dîner",
        breakfast: "Petit déjeuner",
        snack: "Goûter",
      }[this.mealParam];
    },
  },
  mounted() {
    this.reload();
  },
  methods: {
    reload() {
      api
        .get(`/my-meal/${this.dateParam}/${this.mealParam}/`)
        .then((response) => {
          this.meal = response.data;
        });
    },
    humanizeDate(isoDate) {
      const date = new Date(isoDate);
      return date.toLocaleDateString("fr-FR", {
        weekday: "long",
        day: "numeric",
        month: "long",
      });
    },
  },
};
</script>

<style scoped>
.menu-item-image {
  width: 200px;
  object-fit: cover;
  margin-right: 20px;
  border-radius: 10px;
}

.menu-item-name {
  font-size: 20px;
  font-weight: bold;
  color: #3c6610;
  margin-bottom: 1rem;
}

.menu-item-ingredients {
  font-size: 14px;
}
</style>
